import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  locationData: [],
  loading: false,
  error: null,
  lastFetched: null, // Timestamp to track when data was last fetched
  cacheExpiry: 5 * 60 * 1000, // 5 minutes cache expiry
};

const globalLocationSlice = createSlice({
  name: 'globalLocation',
  initialState,
  reducers: {
    setLocationDataStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    setLocationDataSuccess: (state, action) => {
      state.locationData = action.payload;
      state.loading = false;
      state.error = null;
      state.lastFetched = Date.now();
    },
    setLocationDataError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearLocationData: (state) => {
      state.locationData = [];
      state.lastFetched = null;
      state.error = null;
    },
    // Check if cache is still valid
    shouldRefreshCache: (state) => {
      const now = Date.now();
      return !state.lastFetched || (now - state.lastFetched) > state.cacheExpiry;
    }
  },
});

export const {
  setLocationDataStart,
  setLocationDataSuccess,
  setLocationDataError,
  clearLocationData,
  shouldRefreshCache
} = globalLocationSlice.actions;

// Selectors
export const selectLocationData = (state) => state.globalLocation.locationData;
export const selectLocationLoading = (state) => state.globalLocation.loading;
export const selectLocationError = (state) => state.globalLocation.error;
export const selectShouldRefresh = (state) => {
  const now = Date.now();
  const { lastFetched, cacheExpiry } = state.globalLocation;
  return !lastFetched || (now - lastFetched) > cacheExpiry;
};

export default globalLocationSlice.reducer;
